var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound",attrs:{"id":"404"}},[_c('canvas',{staticClass:"canvas"})])
}]

export { render, staticRenderFns }